var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfigurations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.7,
    height: 20.7,
    viewBox: "0 0 20.7 20.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Configurations",
    transform: "translate(0.35 0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M18.7,7.826H17.068a7.358,7.358,0,0,0-.532-1.286l1.15-1.15a1.306,1.306,0,0,0,0-1.846l-1.23-1.23a1.337,1.337,0,0,0-1.845,0l-1.15,1.15a7.378,7.378,0,0,0-1.286-.532V1.3A1.306,1.306,0,0,0,10.87,0H9.13a1.306,1.306,0,0,0-1.3,1.3V2.932a7.392,7.392,0,0,0-1.286.532L5.39,2.314a1.306,1.306,0,0,0-1.845,0L2.313,3.545a1.307,1.307,0,0,0,0,1.845l1.15,1.15a7.378,7.378,0,0,0-.532,1.286H1.3A1.306,1.306,0,0,0,0,9.131V10.87a1.306,1.306,0,0,0,1.3,1.3H2.932a7.392,7.392,0,0,0,.532,1.286l-1.15,1.15a1.306,1.306,0,0,0,0,1.845l1.23,1.231a1.307,1.307,0,0,0,1.845,0l1.15-1.15a7.378,7.378,0,0,0,1.286.532V18.7a1.306,1.306,0,0,0,1.3,1.3H10.87a1.306,1.306,0,0,0,1.3-1.3V17.068a7.378,7.378,0,0,0,1.286-.532l1.15,1.15a1.338,1.338,0,0,0,1.845,0l1.23-1.23a1.306,1.306,0,0,0,0-1.845l-1.15-1.15a7.378,7.378,0,0,0,.532-1.286H18.7a1.306,1.306,0,0,0,1.3-1.3V9.13A1.306,1.306,0,0,0,18.7,7.826Zm.435,3.043a.435.435,0,0,1-.435.435H16.739a.435.435,0,0,0-.421.326,6.535,6.535,0,0,1-.7,1.683.435.435,0,0,0,.067.528l1.383,1.383a.437.437,0,0,1,0,.616l-1.23,1.23a.448.448,0,0,1-.616,0l-1.383-1.383a.435.435,0,0,0-.529-.067,6.512,6.512,0,0,1-1.683.7.434.434,0,0,0-.326.42V18.7a.435.435,0,0,1-.435.435H9.13A.436.436,0,0,1,8.7,18.7V16.739a.435.435,0,0,0-.326-.421,6.519,6.519,0,0,1-1.683-.7.43.43,0,0,0-.221-.06.435.435,0,0,0-.308.127L4.775,17.071a.436.436,0,0,1-.616,0l-1.23-1.23a.435.435,0,0,1,0-.616l1.383-1.383a.434.434,0,0,0,.067-.528,6.528,6.528,0,0,1-.7-1.683.434.434,0,0,0-.42-.326H1.3A.435.435,0,0,1,.87,10.87V9.13A.435.435,0,0,1,1.3,8.7H3.261a.435.435,0,0,0,.421-.326,6.519,6.519,0,0,1,.7-1.683.434.434,0,0,0-.067-.528L2.929,4.775a.436.436,0,0,1,0-.616l1.23-1.23a.436.436,0,0,1,.616,0L6.158,4.312a.434.434,0,0,0,.528.067,6.528,6.528,0,0,1,1.683-.7A.435.435,0,0,0,8.7,3.261V1.3A.435.435,0,0,1,9.13.87H10.87A.435.435,0,0,1,11.3,1.3V3.261a.435.435,0,0,0,.326.421,6.512,6.512,0,0,1,1.683.7.434.434,0,0,0,.529-.067l1.383-1.383a.446.446,0,0,1,.616,0l1.23,1.23a.437.437,0,0,1,0,.616L15.688,6.158a.435.435,0,0,0-.067.528,6.529,6.529,0,0,1,.7,1.683.434.434,0,0,0,.42.326H18.7a.435.435,0,0,1,.435.435Z",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(6.087 6.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M115.913,112a3.913,3.913,0,1,0,3.913,3.913A3.918,3.918,0,0,0,115.913,112Zm0,6.957a3.043,3.043,0,1,1,3.043-3.043A3.047,3.047,0,0,1,115.913,118.957Z",
    transform: "translate(-112 -112)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.7
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurations);
export default __webpack_public_path__ + "static/media/Configurations.88abdb9483729e2d04ad6391acab4616.svg";
export { ForwardRef as ReactComponent };